import { KnowledgeBaseCardMetaData } from "../../../Types/KnowledgeBase";

export const initialData: KnowledgeBaseCardMetaData = {
    files_per_kb: {
        kb_name: "",
        file_count: 0,
        file_size: 0,
        files: [
            {
                file_id: "",
                file_name: ""
            }
        ]
    }
    ,
    urls_per_kb:
    {
        kb_name: "",
        url_count: 0,
        url_size: 0,
        urls: [
            {
                source_url: "",
                domain: ""
            }
        ]
    }

};